import { BUSINESS } from "@/data";
import * as Icons from "lucide-react";

export default function StickyMobileCTA({ onOpenQuote }) {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-slate-200 shadow-[0_-4px_24px_rgba(16,24,36,0.08)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3 gap-2 p-2.5">
        <a
          href={`tel:${BUSINESS.phoneTel}`}
          data-testid="sticky-call-btn"
          className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl bg-brand-red text-white active:scale-95 transition-transform"
        >
          <Icons.Phone className="w-4 h-4" />
          <span className="text-xs font-bold font-display">Call</span>
        </a>
        <a
          href={BUSINESS.directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-directions-btn"
          className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl bg-brand-blue text-white active:scale-95 transition-transform"
        >
          <Icons.MapPin className="w-4 h-4" />
          <span className="text-xs font-bold font-display">Directions</span>
        </a>
        <button
          type="button"
          onClick={onOpenQuote}
          data-testid="sticky-quote-btn"
          className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl bg-slate-100 text-brand-navy border border-slate-200 active:scale-95 transition-transform"
        >
          <Icons.MessageSquareQuote className="w-4 h-4" />
          <span className="text-xs font-bold font-display">Get Quote</span>
        </button>
      </div>
    </div>
  );
}
